const getters = {

    Authorization: state => state.user.Authorization

}
export default getters
